import React, { useState } from 'react';

const stack = ['Vulkan', 'CUDA', 'Unreal Engine 5', 'GLSL / HLSL', 'RenderDoc', 'Ray Tracing'];

const Hero: React.FC = () => {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText('cmateckisavino@gmail.com').then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <section id="home" data-topic="rendering">
      <div className="content hero-content" style={{ paddingBottom: '0.75rem' }}>
        <div className="hero-header">
          <div className="hero-copy">
            <div className="hero-kicker">GPU & Rendering Engineer</div>
            <h1 className="page-title" style={{ marginBottom: '0.35rem' }}>
              Carlos Matecki
            </h1>
            <p className="hero-statement">
              I build rendering and compute systems close to the hardware.
            </p>
            <p className="prose hero-summary" style={{ marginTop: '1rem', marginBottom: '1.25rem' }}>
              Vulkan pipelines, UE5 rendering paths, CUDA kernels, GPU profiling, and real-time optimization work with public code and rendering evidence to back it up.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
              <span className="badge-live">Active</span>
              <span style={{ fontSize: '12px', color: 'var(--fg-3)' }}>
                GPU & Rendering Engineer · Ontario, Canada
              </span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1.25rem' }}>
              <a href="https://www.linkedin.com/in/carlosmatecki/" target="_blank" rel="noopener noreferrer" className="link-btn">
                LinkedIn ↗
              </a>
              <a href="https://github.com/Carcodee" target="_blank" rel="noopener noreferrer" className="link-btn">
                GitHub ↗
              </a>
              <button
                className={`copy-btn${copied ? ' copied' : ''}`}
                onClick={copyEmail}
                aria-label="Copy contact email to clipboard"
              >
                {copied ? 'Copied ✓' : 'Contact'}
              </button>
              <a href="/Carlos_Matecki_Resume.pdf" download className="link-btn">
                Resume ↓
              </a>
            </div>
            <div style={{ fontSize: '11px', color: 'var(--fg-3)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '0.6rem' }}>
              Core Stack
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
              {stack.map(t => (
                <span key={t} className="badge">{t}</span>
              ))}
            </div>
          </div>

          <div className="hero-feature-panel">
            <div className="hero-feature-frame">
              <img
                src="/images/vk1.jpg"
                alt="CodeVkEngine render preview"
                className="hero-feature-image"
              />
            </div>
            <div className="hero-feature-meta">
              <span>CodeVkEngine</span>
              <span>Vulkan render graph, GPU-driven lighting</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
